import { useImportsStore } from '@/stores/ImportsStore'

export const prepareImportsFilters = (cards) => {
  const importsStore = useImportsStore()

  const statusFilters = new Map()
  const dateListedFilters = new Map()
  const categoriesFilters = new Map()
  const productTypeFilters = new Map()

  cards.forEach(item => {
    if (item.status && !statusFilters.has(item.status)) statusFilters.set(item.status, { label: item.status, value: item.status, id: null })
    if (item.cert_data && !dateListedFilters.has(item.cert_data)) dateListedFilters.set(item.cert_data, { label: item.cert_data, value: item.cert_data, id: null })
    if (item.sport && !categoriesFilters.has(item.sport)) categoriesFilters.set(item.sport, { label: item.sports, value: item.sports, id: null })
    if (item.type && !productTypeFilters.has(item.type)) productTypeFilters.set(item.type, { label: item.type, value: item.type, id: null })
  })

  importsStore.statusFilters = { selected: null, items: Array.from(statusFilters.values()) }
  importsStore.dateListedFilters = { selected: null, items: Array.from(dateListedFilters.values()) }
  importsStore.categoriesFilters = { selected: null, items: Array.from(categoriesFilters.values()) }
  importsStore.productTypeFilters = { selected: null, items: Array.from(productTypeFilters.values()) }
}

export const toggleAllImportsRows = () => {
  const importsStore = useImportsStore()
  const haveUnselectedItems = !!importsStore.importCards.find(element => element.select === false)

  if (haveUnselectedItems) {
    importsStore.importCards = importsStore.importCards.map((element, index) => {
      if (!element.select) {
        element.select = true
        if (importsStore.selectedImports.length) {
          importsStore.selectedImports.push(element)
        } else {
          importsStore.selectedImports = [element] 
        }
      }

      return element
    })
  } else {
    importsStore.importCards.forEach(element => {
      if (element.select) {
        element.select = false
        importsStore.selectedImports = []
      }
    })
  }
}